/* global axios */
import ApiClient from '../ApiClient';

class UazapiChannel extends ApiClient {
  constructor() {
    super('channels/uazapi_channels', { accountScoped: true });
  }

  qrCode(id) {
    return axios.get(`${this.url}/${id}/qr_code`);
  }

  status(id) {
    return axios.get(`${this.url}/${id}/status`);
  }

  disconnect(id) {
    return axios.post(`${this.url}/${id}/disconnect`);
  }
}

export default new UazapiChannel();
